export enum XRInputEventType {
  SelectStart,
  Select,
  SelectEnd,
  SqueezeStart,
  Squeeze,
  SqueezeEnd
}
